import React, { useState, useEffect, useRef } from "react";

/** Components */
import {
  TableContainer,
  TableHead,
  TableRow,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  TableCell,
  TableBody,
  Table,
  Paper,
  TablePagination,
  Checkbox,
  Autocomplete,
  Button,
  TableFooter,
  ButtonGroup,
  Dialog,
  Collapse,
  Tooltip,
} from "@mui/material";
import ButtonWithAPICallComponent from "../../commons/ButtonWithAPICall.component";
import { FilterBy } from "../../commons/filter.component";
import SelectStatusButton, { statusOptions } from "../../commons/SelectStatusButton";
import SearchIcon from "@mui/icons-material/Search";
import LoadingProgress from "../../commons/LoadingProgress.component";

/** Icons */
import RefreshIcon from "@mui/icons-material/Refresh";

/** Api & Function */
import { getDriver, updateDriver, updateDriverStatus, postSync, getProvider, createDriver } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
/** Package */

/** Hook */
import { usePagination } from "./../../commons/customHook";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const initialFilter = {
  id: "",
  name: "",
  provider: "",
  status: null,
};

const Driver = () => {
  // custom hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const dataRef = useRef();
  const [page, setPage, rowsPerPage, setRowsPerPage] = usePagination();

  // state
  const [data, setData] = useState();
  const [filter, setFilter] = useState({ ...initialFilter });
  const [isOpen, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [changeIds, setChangeIds] = useState([]);

  // effect
  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN LÁI XE VẬN CHUYỂN"));
    getDriver().then((res) => {
      if (res.code !== 200) return;
      try {
        setData(res.data);
      } catch {}
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    dataRef.current = data;
  }, [data]);
  useEffect(() => {
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  // methods
  const filterFunction = (item) =>
    item.id.toString().contains(filter.id) &&
    item.name?.contains(filter.name) &&
    (filter.provider ? filter.provider.id === item.provider_id : true) &&
    (filter.status === null ? true : item.status === filter.status.label);
  const handleRowClick = (row) => {
    setSelectedRow(row);
  };
  const handleSaveResponse = (res) => {
    if (res.code === 200) {
      setData(dataRef.current.map((item) => (item.id === selectedRow.id ? { ...res.data, status: item.status } : item)));
      setSelectedRow(null);
    }
  };
  const handleCheckBoxClick = (id) => {
    if (changeIds.includes(id)) setChangeIds((prev) => prev.filter((item) => item !== id));
    else setChangeIds((prev) => [...prev, id]);
  };
  const handleUpdateStatus = (selectedStatus) => {
    return updateDriverStatus({ ids: changeIds, action: selectedStatus.action });
  };
  const handleUpdateStatusResponse = (res, selectedStatus) => {
    if (res.code === 200) {
      let newStatus;
      switch (selectedStatus.action) {
        case 0:
          newStatus = "DEACTIVATED";
          break;
        case 1:
          newStatus = "ACTIVATED";
          break;
        case 4:
          setChangeIds([]);
          newStatus = "DELETED";
          break;
        default:
          break;
      }
      setData((prev) => prev.map((item) => (changeIds.includes(item.id) ? { ...item, status: newStatus } : item)));
    }
  };
  const handleCreateResponse = (res) => {
    if (res.code === 200) {
      setData([...dataRef.current, res.data]);
    }
  };
  return (
    <div>
      {!data ? (
        <LoadingProgress />
      ) : (
        <div align="left">
          <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}>
            <ButtonGroup style={{ height: 40, marginRight: 10 }}>
              <ButtonWithAPICallComponent title="Cập nhật dữ liệu từ ERP" api={() => postSync({ object: "driver" })} variant="outlined">
                <RefreshIcon />
              </ButtonWithAPICallComponent>
              <Button onClick={() => setOpen((prev) => !prev)}>
                <Tooltip title="Thư mục">
                  <SearchIcon />
                </Tooltip>
              </Button>
            </ButtonGroup>
          </div>
          {/* filter */}
          <Collapse in={isOpen} sx={{ marginBottom: "20px" }} align="center">
            <TextField sx={{ margin: "5px" }} value={filter.id} onChange={(e) => setFilter((prev) => ({ ...prev, id: e.target.value }))} label="ID" />
            <TextField sx={{ margin: "5px" }} value={filter.name} onChange={(e) => setFilter((prev) => ({ ...prev, name: e.target.value }))} label={t("Họ và tên")} />
            <FilterBy
              getDataFunc={() => getProvider()}
              sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
              label={t("Đơn vị vận chuyển")}
              onChange={(e, newValue) => setFilter((prev) => ({ ...prev, provider: newValue }))}
              value={filter.provider}
            />
            <Autocomplete
              sx={{ display: "inline-flex", minWidth: 200, margin: "5px" }}
              options={statusOptions}
              getOptionLabel={(option) => t(option.label) || ""}
              value={filter.value}
              onChange={(e, newValue) => setFilter((prev) => ({ ...prev, status: newValue }))}
              renderInput={(params) => <TextField {...params} label={t("Trạng thái")} />}
            />
          </Collapse>

          <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>ID</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Họ và tên")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Đơn vị vận chuyển")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{t("Trạng thái")}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>
                    <SelectStatusButton disabled={!changeIds.length} api={handleUpdateStatus} response={handleUpdateStatusResponse} />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.filter(filterFunction) ? (
                  data
                    .filter(filterFunction)
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={row.id} hover style={{ cursor: "pointer" }} onClick={(e) => e.target.type !== "checkbox" && handleRowClick(row)}>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{row.id} </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {row.name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {row.provider_name}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>{t(row.status)}</TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }}>
                          <Checkbox disabled={row.status === "DELETED"} checked={changeIds.includes(row.id)} onClick={handleCheckBoxClick.bind(this, row.id)} />
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={14}>{t("Không có dữ liệu")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    count={data?.filter(filterFunction).length || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={setRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
          <EditDriver initialData={selectedRow} onSaveResponse={handleSaveResponse} onClose={() => setSelectedRow(null)} />
          <CreateDriver open={Boolean(selectedRow === 0)} onClose={() => setSelectedRow(null)} onSubmitResponse={handleCreateResponse} />
        </div>
      )}
    </div>
  );
};
export default Driver;

const EditDriver = ({ initialData, onSave, onSaveResponse, onClose }) => {
  const [t] = useTranslation();
  const [inputData, setInputData] = useState({
    name: "",
    pid: "",
    phone: "",
    email: "",
    provider: null,
  });
  const setDefaultFunc = (option) => {
    let newProvider = option.find((item) => item.id === initialData.provider_id) || null;
    setInputData((prev) => ({ ...prev, provider: newProvider }));
  };
  const handleSave = () => {
    // call save api
    return updateDriver(initialData.id, {
      name: inputData.name,
      pid: inputData.pid,
      email: inputData.email,
      phone: inputData.phone,
      code: inputData.code,
      provider_id: inputData.provider?.id,
    });
  };
  useEffect(() => {
    if (!initialData) return;
    setInputData((prev) => ({
      name: initialData.name,
      id: initialData.id,
      pid: initialData.pid || "",
      phone: initialData.phone || "",
      email: initialData.email || "",
      provider: null,
    }));
  }, [initialData]);
  return (
    <Dialog open={Boolean(initialData)} onClose={onClose} maxWidth={false}>
      <DialogTitle align="center">{t("Chỉnh sửa thông tin người lái xe")}</DialogTitle>
      <DialogContent sx={{ width: { sm: "500px", xs: "auto" } }}>
        <div style={{ display: "grid", rowGap: 10, marginTop: 10 }}>
          <TextField fullWidth label={t("Họ và tên")} value={inputData.name} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} />
          <TextField fullWidth label={t("CCCD/CMT")} value={inputData.pid || ""} onChange={(e) => setInputData((prev) => ({ ...prev, pid: e.target.value }))} />
          <TextField fullWidth label={t("Điện thoại")} alignitems="left" value={inputData.phone || ""} onChange={(e) => setInputData((prev) => ({ ...prev, phone: e.target.value }))} />
          <TextField fullWidth label={t("Email")} alignitems="left" value={inputData.email || ""} onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))} />
          <FilterBy
            triggerSetDefaultFunc={initialData}
            setDefaultFunc={(option) => setDefaultFunc(option)}
            getDataFunc={() => getProvider()}
            value={inputData.provider}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, provider: newValue }))}
            label={t("Đơn vị vận chuyển")}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent variant="contained" api={handleSave} response={onSaveResponse}>
          {t("Lưu")}
        </ButtonWithAPICallComponent>
      </DialogActions>
    </Dialog>
  );
};
const CreateDriver = ({ open, onClose, onSubmitResponse }) => {
  const [t] = useTranslation();

  const [inputData, setInputData] = useState({
    name: "",
    phone: "",
    pid: "",
    email: "",
    provider: null,
  });
  const handleSubmit = () => {
    return createDriver({ ...inputData, provider_id: inputData.provider?.id });
  };
  return (
    <Dialog open={Boolean(open)} onClose={onClose} fullWidth>
      <div style={{ padding: "20px 10px 50px 10px", display: "grid", gridGap: 10, position: "relative" }} align="center">
        <DialogTitle>{t("Tạo người lái xe")}</DialogTitle>
        <DialogContent>
          <TextField label={t("Họ và tên")} value={inputData.name} onChange={(e) => setInputData((prev) => ({ ...prev, name: e.target.value }))} />
          <TextField label={t("CCCD/CMT")} value={inputData.pid || ""} onChange={(e) => setInputData((prev) => ({ ...prev, pid: e.target.value }))} />
          <TextField label={t("Điện thoại")} value={inputData.phone || ""} onChange={(e) => setInputData((prev) => ({ ...prev, phone: e.target.value }))} />
          <TextField label={t("Email")} value={inputData.email || ""} onChange={(e) => setInputData((prev) => ({ ...prev, email: e.target.value }))} />
          <FilterBy
            getDataFunc={() => getProvider({ status: 1 })}
            value={inputData.provider}
            onChange={(e, newValue) => setInputData((prev) => ({ ...prev, provider: newValue }))}
            label={t("Đơn vị vận chuyển")}
          />
        </DialogContent>
      </div>
      <div style={{ position: "absolute", bottom: 10, right: 10 }} align="right">
        <Button onClick={onClose}>{t("Hủy")}</Button>
        <ButtonWithAPICallComponent disabled={!Object.keys(inputData).every((key) => inputData[key])} variant="contained" api={handleSubmit} response={onSubmitResponse}>
          {t("Tạo mới")}
        </ButtonWithAPICallComponent>
      </div>
    </Dialog>
  );
};
